var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilePdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 5.5V12.8333C25.6667 13.3196 25.8598 13.7859 26.2036 14.1297C26.5474 14.4735 27.0138 14.6667 27.5 14.6667H34.8333",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 22V9.16667C9.16666 8.19421 9.55296 7.26158 10.2406 6.57394C10.9282 5.88631 11.8609 5.5 12.8333 5.5H25.6667L34.8333 14.6667V22",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 33H11.9167C12.646 33 13.3455 32.7103 13.8612 32.1945C14.3769 31.6788 14.6667 30.9793 14.6667 30.25C14.6667 29.5207 14.3769 28.8212 13.8612 28.3055C13.3455 27.7897 12.646 27.5 11.9167 27.5H9.16666V38.5",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 33H34.8333",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 27.5H31.1667V38.5",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 27.5V38.5H22C22.9725 38.5 23.9051 38.1137 24.5927 37.4261C25.2803 36.7384 25.6667 35.8058 25.6667 34.8333V31.1667C25.6667 30.1942 25.2803 29.2616 24.5927 28.5739C23.9051 27.8863 22.9725 27.5 22 27.5H20.1667Z",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePdf);
export default __webpack_public_path__ + "static/media/Icon_File_PDF.0598099288acc2faab1b6305edcd3b21.svg";
export { ForwardRef as ReactComponent };